import { Theme } from '@mui/material/styles';

export const getMuiPopover = (theme: Theme): any => ({
  MuiPopover: {
    styleOverrides: {
      paper: {
        maxHeight: '400px',
        boxShadow: `0px 6px 12px ${theme.palette.grey[400]}`,
      },
    },
  },
});
